import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {ApiServiceService} from '../api-service.service';
import {VerificationState} from '../model/verification-state.model';
import {Keys, StorageService} from '../service/storage.service';
import {AnalyticsTracker} from '../utils/AnalyticsTracker';
import {ReferralPartnerCodeComponent} from '../referral-input/referral-partner-code.component';
import {executeWithLoader, LoaderStatus} from '../utils/loader.util';

@Component({
    selector: 'app-lenderintro',
    templateUrl: './lenderintro.component.html',
    styleUrls: ['./lenderintro.component.css']
})

export class LenderintroComponent implements OnInit {
    @ViewChild(ReferralPartnerCodeComponent)
    referralInput: ReferralPartnerCodeComponent;

    referralFeatureEnabled = ApiServiceService.isReferralSchemeEnabled();
    isUserRegistered: boolean;
    loaderStatus = new LoaderStatus();

    constructor(private router: Router, private storageService: StorageService, public analyticsTracker: AnalyticsTracker) {
    }

    ngOnInit() {
        this.isUserRegistered = !!this.storageService.getItem(Keys.PROFILE_ID);
    }

    async verifyAndProceed() {
        await executeWithLoader(this.loaderStatus, async () => {
            if (!this.referralFeatureEnabled) {
                await this.goToPanVerification();
            } else {
                const verificationState = await this.referralInput.verifyReferralCode();
                if (verificationState === VerificationState.VERIFIED || verificationState === VerificationState.NA) {
                    await this.goToPanVerification();
                } else if (verificationState === VerificationState.PARTNER_VERIFIED) {
                    await this.goToConsent();
                }
            }
        });
    }

    private async goToPanVerification() {
        await this.router.navigate(['/invest/pan-verification']);
    }

    private async goToConsent() {
        await this.router.navigate(['/invest/referral-consent']);
    }
}
